import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { FLOW_TEXT_INPUT_BASE } from "../../styles/twDesignPrimitives";

type SearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  children?: ReactNode;
};

export function ListSearchFilters({
  value,
  onChange,
  placeholder,
  children,
}: SearchProps) {
  return (
    <div className="mb-6 mt-4 flex w-full flex-col gap-3 md:flex-row md:flex-wrap md:items-end">
      <label className="flex min-w-0 flex-1 flex-col gap-1 text-xs font-medium text-slate-600 md:max-w-md">
        Busca
        <input
          className={FLOW_TEXT_INPUT_BASE}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
        />
      </label>
      {children}
    </div>
  );
}

type SelectProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: ReadonlyArray<{ value: string; label: string }>;
};

export function ListFilterSelect({
  label,
  value,
  onChange,
  options,
}: SelectProps) {
  return (
    <label className="flex min-w-[160px] flex-col gap-1 text-xs font-medium text-slate-600">
      {label}
      <select
        className={FLOW_TEXT_INPUT_BASE}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value || "all"} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export function ListEmptyState({ message }: { message: string }) {
  return (
    <p className="mt-8 rounded-md border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center text-sm text-slate-500">
      {message}
    </p>
  );
}

export function ListTableLoading() {
  return (
    <div
      className="flex items-center justify-center py-16"
      role="status"
      aria-label="Carregando"
    >
      <Loader2 className="h-10 w-10 animate-spin text-[#DD6435]" />
    </div>
  );
}
